import { CALLBACK_STATE } from '@callback/app/constants/callback-state.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const CALLBACK_MODULE_STATE: Ng2StateDeclaration = {
  name: `${CALLBACK_STATE.CALLBACK}.**`,
  url: '/callback',
  loadChildren: () => import('@callback/app/callback.module').then((m) => m.CallbackModule),
};
export const APP_STATES = [CALLBACK_MODULE_STATE];
